document.addEventListener('DOMContentLoaded', () => {
    const calculateButton = document.getElementById('calculate-gemstone-weight');
    const shapeInput = document.getElementById('gemstone-shape');
    const lengthInput = document.getElementById('gemstone-length');
    const widthInput = document.getElementById('gemstone-width');
    const depthInput = document.getElementById('gemstone-depth');
    const sgInput = document.getElementById('gemstone-sg');
    const resultSpan = document.getElementById('gemstone-result');

    // IMPORTANT: REPLACE THIS PLACEHOLDER WITH YOUR ACTUAL CLOUDFLARE WORKER URL
    // Example: 'https://gemstone-calculator-api.your-username.workers.dev'
    const workerUrl = 'https://shopify-gem-calculator.garethjbutterworth.workers.dev'; // <--- REPLACE THIS LINE!

    // Check if the calculator elements exist on the page before attaching event listeners
    if (calculateButton && shapeInput && lengthInput && widthInput && depthInput && sgInput && resultSpan) {
        calculateButton.addEventListener('click', async () => {
            const shape = shapeInput.value;
            const length = parseFloat(lengthInput.value);
            const width = parseFloat(widthInput.value);
            const depth = parseFloat(depthInput.value);
            const specificGravity = parseFloat(sgInput.value);

            // Client-side validation: ensure all inputs are numbers and shape is selected
            if (!shape || isNaN(length) || isNaN(width) || isNaN(depth) || isNaN(specificGravity)) {
                resultSpan.textContent = 'Please fill in all fields with valid numbers.';
                resultSpan.style.color = 'red'; // Provide visual feedback for error
                return;
            }

            // Reset color in case of previous error
            resultSpan.style.color = '#28a745';

            try {
                // Make a POST request to your Cloudflare Worker
                const response = await fetch(workerUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // No custom API keys needed here unless you added them to your Worker
                    },
                    body: JSON.stringify({
                        shape: shape,
                        length: length,
                        width: width,
                        depth: depth,
                        specificGravity: specificGravity
                    })
                });

                // Check if the request was successful (HTTP status 200-299)
                if (!response.ok) {
                    let errorMessage = `Calculation failed! Status: ${response.status}.`;
                    try {
                        const errorData = await response.json();
                        if (errorData && errorData.error) {
                            errorMessage = `Error: ${errorData.error}`;
                        } else {
                            errorMessage = `Error: ${JSON.stringify(errorData)}`;
                        }
                    } catch (e) {
                        // If response is not JSON, use the raw text
                        errorMessage = `Error: ${await response.text()}`;
                    }
                    throw new Error(errorMessage);
                }

                // Parse the JSON response from your Worker
                const data = await response.json();

                // Display the calculated weight
                resultSpan.textContent = `${data.weight}`; // ' carats' is already in HTML
            } catch (error) {
                console.error('Error calculating gemstone weight:', error);
                resultSpan.textContent = `Calculation failed: ${error.message}`;
                resultSpan.style.color = 'red';
            }
        });
    } else {
        console.warn('Gemstone calculator elements not found on the page. Ensure HTML is loaded.');
    }
});